import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BansStorageService {
  private bansApiResponseList = new BehaviorSubject<any>(null);
  private bansList = new BehaviorSubject<any>(null);
  private bansTSAList = new BehaviorSubject<any>(null);
  private banPresentFlag = new BehaviorSubject<boolean>(false);
  private banApiCallStatus = new BehaviorSubject<string>('callByCustomerId');
  
  public bansApiResponse = this.bansApiResponseList.asObservable();
  public bans = this.bansList.asObservable();
  public bansTSA = this.bansTSAList.asObservable();
  public banFlag = this.banPresentFlag.asObservable();
  public banApiStaus = this.banApiCallStatus.asObservable();

  setBansApiResponse(bans: any) {
    this.bansApiResponseList.next(bans);
  }

  setBans(bans: any) {
    this.bansList.next(bans);
  }

  setTSABans(bans: any) {
    this.bansTSAList.next(bans);
  }

  setBanPresentFlag(isPresent: boolean) {
    this.banPresentFlag.next(isPresent);
  }

  setBanCallingStatus(apiCallStatus: string) {
    this.banApiCallStatus.next(apiCallStatus);
  }
}
